// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBsFRX8Nnrj1-0Fh_CZA4k5qIBCSKaaxco",
  authDomain: "lxt-web.firebaseapp.com",
  databaseURL: "https://lxt-web.firebaseio.com",
  projectId: "lxt-web",
  storageBucket: "lxt-web.appspot.com",
  messagingSenderId: "61498828181",
  appId: "1:61498828181:web:5ffa2f3521d3dd7a54029c",
  measurementId: "G-SXG7LYS0P1",
};

export default firebaseConfig;
